import { AxiosProgressEvent } from 'axios'
import { DOCUMENT_SECURITY_STATUS, MULTI_UPLOAD_FILE_TYPE } from '../constants'

export interface AppComponentProps {
  name?: string
}
export interface FileDetails {
  lastModified: number
  lastModifiedDate: Date
  name: string
  size: number
  type: string
  webkitRelativePath: string
}
export interface FileMetadata {
  access_type: string
  aws_file_name: string
  entity_id: number
  exact_path: string
  field_id: number
  file_name: string
  file_size: number
  file_type: string
  id: number
  pre_signed_url: string
}
export interface FileUploadProgressProps {
  fileName: string
  uploadedSize?: AxiosProgressEvent
  totalSize: number
  progress?: number
  onCancel: (index: number, clearForEdit?: boolean) => void
  index: number
  handlePreviewToggle: (
    index: number,
    fileType: MULTI_UPLOAD_FILE_TYPE_VALUES_TYPE,
    type?: string,
    editMode?: boolean,
    isDownload?: boolean,
    fileName?: string
  ) => Promise<void>
  fileType: MULTI_UPLOAD_FILE_TYPE_VALUES_TYPE
  viewMode: boolean
  editMode?: boolean
  disableRemove?: boolean
  auditHistoryValue?: string
  disabled: boolean
  isOpenForListing?: boolean
  tabIndex?: number
  isUploadDisabled?: boolean
  securityStatus?: DOCUMENT_SECURITY_STATUS
  securityReason?: string | null
}
export type MULTI_UPLOAD_FILE_TYPE_KEYS_TYPE =
  keyof typeof MULTI_UPLOAD_FILE_TYPE
export type MULTI_UPLOAD_FILE_TYPE_VALUES_TYPE =
  (typeof MULTI_UPLOAD_FILE_TYPE)[MULTI_UPLOAD_FILE_TYPE_KEYS_TYPE]

export const safeRegexForSpecialChar = /^[\p{L}\p{N}._()\-, /'’®]+$/u

export interface FileTypeComponentIconProps {
  fileType: MULTI_UPLOAD_FILE_TYPE_VALUES_TYPE
  smallIcon?: boolean
}
const ToasterType = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
} as const
export type ToasterTypeValues = (typeof ToasterType)[keyof typeof ToasterType]

export interface FileDataFromExtraResourceSingleUpload {
  file_size: number
  id: number
  file_type: string
  record_status: string
  file_name: string
  aws_file_name: string
  created_at: string
  created_by: string
}
export interface FileDataFromExtraResource {
  size: number
  id: number
  content_type: string
  record_status: string
  name: string
  url: string
  created_at: string
  created_by: string
  contentType?: string
  status?: DOCUMENT_SECURITY_STATUS
  reason?: string
}
export interface BulkUploadPreSignedUrl {
  id: number
  name: string
  aws_file_name: string
  content_type: string
  size: number
  entity_id: number
  field_id: number
  access_type: string
  exact_path: string
  pre_signed_url: string
}
export interface FileUploadMetadata {
  type: string
  created_by: string | null
  created_at: string | null
  modified_at: string | null
  modified_by: string | null
  name: string
  alias: string | null
  path: string
  size: string
  content_type: string
  extension: string | null
  tagging: string | null
  url: string
  entity_id: number
  field_id: number
  access_type: string
}